import { render, staticRenderFns } from "./CatalogueCollectionList.vue?vue&type=template&id=74bac318&scoped=true&"
import script from "./CatalogueCollectionList.vue?vue&type=script&lang=js&"
export * from "./CatalogueCollectionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74bac318",
  null
  
)

export default component.exports